<template>
    <v-card class="card-container">
        <v-card-title class="py-0">
            <v-row>
                <v-col cols="auto">
                    <v-btn
                            @click="showAddModal"
                            color="var(--color-blue)"
                            dark
                            dense
                    >
                        <span class="btn-text"><v-icon dark>add</v-icon> Добавить партнера</span>
                    </v-btn>
                </v-col>
                <v-col>
                    <v-text-field
                            class="search-block"
                            dense
                            hide-details
                            placeholder="Поиск партнеров"
                            prepend-inner-icon="mdi-magnify"
                            single-line
                            solo
                            v-model="search"
                    />
                </v-col>

                <v-spacer></v-spacer>
            </v-row>
        </v-card-title>
        <v-card-text class="h-100 p-0" style="overflow-y: scroll">
            <v-container class="h-100" fluid>
                <v-data-table
                        :headers="fields"
                        :items="filteredItems"
                        :items-per-page="filteredItems.length"
                        :loading="loading"
                        :search="search"
                        calculate-widths
                        class="elevation-1 h-100"
                        height="100%"
                        hide-default-footer
                        loading-text="Загрузка данных"
                        no-data-text="Нет элементов"
                        no-results-text="Не найдено элементов"
                >
                    <template v-slot:item.subordinateOrgSmallLogo="{item}">
                        <img
                                :src="$root.docsUrl+item.subordinateOrgSmallLogo"
                                alt="лого"
                                class="my-1"
                                height="50px"
                                v-if="item.subordinateOrgSmallLogo!=null"
                                width="50px"
                        >
                        <img class="my-1" height="50" src="../../assets/noavatar.png" v-else width="50"/>
                    </template>

                    <template v-slot:item.delete="{item}">
                        <v-btn @click="removePartnerFromGrid(item)" icon>
                            <v-icon large>mdi-delete</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-container>
        </v-card-text>
        <addPartnerModal :organizationItem="item" :show="showAdd" @close="closeAdd"></addPartnerModal>
    </v-card>
</template>

<script>
    import addPartnerModal from '../dictionaries/PartnerGrid/AddPartnerToGridModal.vue'

    export default {
        name: "PartnerInfoGrid",
        props: ["item"],
        components: {
            addPartnerModal
        },
        data() {
            return {
                loading: false,
                search: "",
                showAdd: false,
                fields: [
                    {text: 'Лого', value: 'subordinateOrgSmallLogo', width: '60px'},
                    {text: 'Наименование', value: 'subordinateOrgName', sortable: true},
                    {text: '', value: 'delete', width:'60px'},
                ],
            }
        },
        mounted() {
            //Запрашиваем список всех партнеров из нашей сетки
            this.getGridItems();
        },
        computed: {
            //Обработка фильтра,сортировка и вывод списка партнеров в сетке
                filteredItems() {
                const gridItems = this.$store.state.Partners.partnerGrid;

                if (gridItems !== null) {
                    return gridItems.filter((elem) => {
                        return new RegExp(this.search, 'ig').test(elem.subordinateOrgName);
                    }).sort((a, b) => {
                        const nameA = a.subordinateOrgName.toLowerCase(), nameB = b.subordinateOrgName.toLowerCase()
                        if (nameA < nameB) //сортируем строки по возрастанию
                            return -1
                        if (nameA > nameB)
                            return 1
                        return 0
                    });
                }
                else return [];
            },
        },
        methods: {
            //Получаем список всех партнеров из нашей сетки
            getGridItems() {
                const vm = this;
                this.loading = true
                this.$store.dispatch("Partners/getPartnerGrid", this.item.id).then(x => {
                    vm.loading = false
                }).catch((err) => {
                    console.log(err)
                    this.loading = false;
                    this.$bvToast.toast(err.message, {
                        title: `Ошибка загрузки сетки партнеров!`,
                        variant: "danger",
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 3000,
                        solid: true
                    })
                });
            },

            //Удаляем партнера из сетки
            removePartnerFromGrid(item) {
                const vm = this;
                this.$bvModal.msgBoxConfirm('Вы действительно хотите удалить запись?', {
                    title: 'Подтверждение',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Удалить',
                    cancelTitle: 'Отмена',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                    .then((value) => {
                    if (value) {
                        vm.$store.dispatch("Partners/removePartnerFromGrid", item.id)
                    }
                }).catch(e => {
                    vm.$bvToast.toast(e.message, {
                        title: `Ошибка удаления партнера!`,
                        variant: "danger",
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 3000,
                        solid: true
                    })
                });
            },

            showAddModal() {
                this.showAdd = true
            },

            closeAdd(isSave) {
                this.showAdd = false
                if (isSave === true) {
                    this.getGridItems()
                }
            },
        },
    }
</script>

<style scoped>

</style>